module.exports = __webpack_public_path__ + "static/media/chevron-black.2f8d9880.svg";